import { render } from "./NoFavoritePoints.vue?vue&type=template&id=23b1bbd7"
import script from "./NoFavoritePoints.vue?vue&type=script&lang=js"
export * from "./NoFavoritePoints.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__